import { combineReducers } from "@reduxjs/toolkit"
import undoable from "redux-undo"
import { currentStepGroup } from "../helpers/stepUndoGroup.helpers"
import objectsReducer from "./slices/objects.slice"

/**
 * How many undo steps are kept.
 *
 * `redux-undo` defaults to `limit: undefined`, which its `insert()` evaluates as "never
 * overflow" — the past grew for as long as the tab was open. Every entry holds a full
 * `objects.value` map plus the pre-edit version of every object it touched (styles, fill,
 * filters, transforms, animations), so nothing an editing session ever produced was
 * collectable. On a graphic with a few hundred objects that is the single largest retainer
 * in the heap.
 */
const UNDO_HISTORY_LIMIT = 100

const undoableReducer = undoable(
    combineReducers({
        objects: objectsReducer,
    }),
    {
        limit: UNDO_HISTORY_LIMIT,
        // a run of stepping one number field is one undo step (see stepUndoGroup.helpers)
        groupBy: () => currentStepGroup(),
    }
)

export default undoableReducer
